import AgencyHelper, { AgencyConstants } from 'features/Agency/agencyHelper';
import CustomDropdown2 from 'general/components/Others/CustomDropdown2';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import PropTypes from 'prop-types';
import { useMemo, useState } from 'react';
import AgencyCreateContractView from '../AgencyCreateContractView';

AgencyDirectInvestorContractCreateView.propTypes = {
  operatorId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onCancel: PropTypes.func,
  onSuccess: PropTypes.func,
};

function AgencyDirectInvestorContractCreateView({ operatorId, onCancel, onSuccess }) {
  const [selectedAgency, setSelectedAgency] = useState(null);
  const investorRootItem = useMemo(
    () => ({
      name: 'Nhà đầu tư nhượng quyền',
      role: AgencyConstants.AgencyRole.INVESTOR,
    }),
    []
  );

  const validate = () => {
    if (!selectedAgency?.id) {
      ToastHelper.showError('Vui lòng chọn nhà đầu tư nhượng quyền');
      return false;
    }
    if (!operatorId) {
      ToastHelper.showError('Chưa cấu hình nhà điều hành cho hợp đồng');
      return false;
    }
    return true;
  };

  const agencySelector = (
    <div className="w-100 text-left mt-3">
      {UIHelper.buildFormLabel('Nhà đầu tư nhượng quyền', true)}
      <CustomDropdown2
        ignoreConfirmClick={true}
        name="directInvestorAgencyId"
        id="directInvestorAgencyId"
        toggleElement={
          <button
            className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
            type="button"
          >
            {selectedAgency?.name || 'Chọn nhà đầu tư nhượng quyền'}
          </button>
        }
        selectedValue={selectedAgency}
        subTitleType="email"
        dropdownMenuItems={[investorRootItem]}
        getSubItems={async (item) => {
          const data = await AgencyHelper.API.requestGetAgencyList({
            role: AgencyConstants.AgencyRole.INVESTOR,
            page: item?.page || 0,
            limit: 10,
            q: item?.q || '',
          });
          return {
            values: (data?.agencies || []).map((agency) => ({
              id: agency.agencyId,
              name: agency.name,
              email: agency.email,
              item: agency,
            })),
            total: data?.total || 0,
          };
        }}
        dropdownMenuStyle={{ maxHeight: '35vh' }}
        dropdownMenuClassName="overflow-auto w-100"
        onChange={setSelectedAgency}
        isDropdownForm={true}
        searchable={true}
        searchFormClassName="mx-3 my-1 search-form-border"
        defaultValue={investorRootItem}
      />
      {selectedAgency?.item?.phone && (
        <div className="mt-2 text-muted">
          Số điện thoại: {selectedAgency.item.phone}
        </div>
      )}
    </div>
  );

  return (
    <AgencyCreateContractView
      title="Thêm hợp đồng NĐT nhượng quyền"
      contentEl={agencySelector}
      agency={selectedAgency?.item}
      contractRole={AgencyConstants.ContractRole.INVESTOR}
      paperOnly={true}
      onValidate={validate}
      onCancel={onCancel}
      onConfirm={async (params) => {
        const result = await AgencyHelper.API.requestCreateDirectInvestorContract({
          ...params,
          agencyId: selectedAgency.id,
          operatorId,
        });
        if (result && typeof result === 'object') {
          ToastHelper.showSuccess('Tạo hợp đồng NĐT nhượng quyền thành công');
          if (onSuccess) onSuccess(result);
          return;
        }
        ToastHelper.showError(result || 'Tạo hợp đồng NĐT nhượng quyền thất bại');
      }}
    />
  );
}

export default AgencyDirectInvestorContractCreateView;
